<template>
  <div>
    <sticky>
      <section class="shadow" v-if="characters">
        <character-panel v-for="character in characters"
                         :key="character.characterId"
                         :character-id="character.characterId"
                         :opened="opened"
                         @selected="onSelected">
        </character-panel>
        <character-panel key="panel-vault" character-id="VAULT" :opened="opened" @selected="onSelected"></character-panel>
        <button @click.prevent="openMenu" v-show="!opened"></button>
      </section>
    </sticky>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import CharacterPanel from '@/components/CharacterPanel'
  import Sticky from '@/components/Sticky'

  export default {
    name: 'panels',
    data () {
      return {
        opened: false
      }
    },
    computed: {
      ...mapState('destiny/profile', ['characters'])
    },
    methods: {
      openMenu () {
        this.opened = true
      },
      onSelected (characterId) {
        this.opened = false
        this.$router.push({
          name: 'manager',
          params: {character: characterId}
        })
      }
    },
    components: {
      CharacterPanel,
      Sticky
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/settings";

  section {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    z-index: 2;
    background-color: $body-background;
    overflow: auto;
  }

  button {
    display: none;
  }

  @media #{$media-phone} {
    $button-size: 100%;
    section {
      display: block;
      width: 100%
    }
    button {
      cursor: pointer;
      display: block;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: $button-size;
      border: 0;
      opacity: 0;
    }

  }

  .spacer {
    height: 3rem;
    margin-top: .5rem;
  }


</style>



// WEBPACK FOOTER //
// Panels.vue?5f3a954a